import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic"

import styles from "./ArticleThumbnail.module.scss"

function ArticleThumbnail({ image, width }) {

  if(image && image.filename) {
    return (
      <div className={styles.articleThumbnail}>
        <div className={styles.container}>
          <StoryblokImageBasic image={image} width={width} />
        </div>
      </div>
    )
  }
  return null
}

export default ArticleThumbnail
